import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ContractAgreementsAnalytics from '@/components/contracts/ContractAgreementsAnalytics';
import ContractAgreementsRecords from '@/components/contracts/ContractAgreementsRecords';
import { FileSignature } from 'lucide-react';

export default function ContractAgreements() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <FileSignature className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Contract Agreements</h1>
                </div>
                <p className="text-muted-foreground">Signed contract documents (driver & witness).</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <ContractAgreementsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <ContractAgreementsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
